import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import '../styles/legal-pages.css';

export default function PrivacyPolicy() {
	const { t } = useTranslation();
	const section2_2Items = t('privacy.section2_2Items', { returnObjects: true });
	const section3Headers = t('privacy.section3Headers', { returnObjects: true });
	const section3Rows = t('privacy.section3Rows', { returnObjects: true });
	const section4Headers = t('privacy.section4Headers', { returnObjects: true });
	const section4Rows = t('privacy.section4Rows', { returnObjects: true });
	const section6Items = t('privacy.section6Items', { returnObjects: true });
	const section7Rights = t('privacy.section7Rights', { returnObjects: true });

	const privacyLinks = [
		'https://policies.google.com/privacy',
		'https://policies.google.com/privacy',
		'https://policies.google.com/privacy',
		'https://firebase.google.com/support/privacy',
		'https://www.emailjs.com/legal/privacy-policy/',
	];

	return (
		<div className="legal-page">
			<Helmet>
				<title>{t('privacy.pageTitle')}</title>
				<meta name="description" content={t('privacy.metaDescription')} />
				<meta name="robots" content="noindex, follow" />
			</Helmet>

			<div className="legal-container">
				<h1>{t('privacy.title')}</h1>
				<p className="legal-subtitle">{t('privacy.subtitle')}</p>
				<p className="legal-updated">{t('privacy.lastUpdated')}</p>

				<section>
					<h2>{t('privacy.section1Title')}</h2>
					<p>
						{t('privacy.section1Text')}<br />
						<strong>Ing. Eleonora Bernasconi - Studio di Ingegneria dell'Informazione</strong><br />
						Via del Sudario 35, 00186 Roma (RM), Italia<br />
						Email: <a href="mailto:info@ingegneriabernasconi.it">info@ingegneriabernasconi.it</a><br />
						Tel: <a href="tel:+390656558610">+39 06 5655 8610</a>
					</p>
				</section>

				<section>
					<h2>{t('privacy.section2Title')}</h2>
					<h3>{t('privacy.section2_1Title')}</h3>
					<p>{t('privacy.section2_1Text')}</p>
					<h3>{t('privacy.section2_2Title')}</h3>
					<p>{t('privacy.section2_2Text')}</p>
					<ul>
						{section2_2Items.map((item, i) => <li key={i}>{item}</li>)}
					</ul>
					<h3>{t('privacy.section2_3Title')}</h3>
					<p>
						{t('privacy.section2_3Text')}{' '}
						<a href="/cookie-policy">Cookie Policy</a>.
					</p>
				</section>

				<section>
					<h2>{t('privacy.section3Title')}</h2>
					<table className="legal-table">
						<thead>
							<tr>
								{section3Headers.map((h, i) => <th key={i}>{h}</th>)}
							</tr>
						</thead>
						<tbody>
							{section3Rows.map((row, i) => (
								<tr key={i}>
									{row.map((cell, j) => <td key={j}>{cell}</td>)}
								</tr>
							))}
						</tbody>
					</table>
				</section>

				<section>
					<h2>{t('privacy.section4Title')}</h2>
					<p>{t('privacy.section4Text')}</p>
					<table className="legal-table">
						<thead>
							<tr>
								{section4Headers.map((h, i) => <th key={i}>{h}</th>)}
							</tr>
						</thead>
						<tbody>
							{section4Rows.map((row, i) => (
								<tr key={i}>
									{row.map((cell, j) => <td key={j}>{cell}</td>)}
									<td><a href={privacyLinks[i]} target="_blank" rel="noopener noreferrer">Link</a></td>
								</tr>
							))}
						</tbody>
					</table>
				</section>

				<section>
					<h2>{t('privacy.section5Title')}</h2>
					<p>{t('privacy.section5Text')}</p>
				</section>

				<section>
					<h2>{t('privacy.section6Title')}</h2>
					<ul>
						{section6Items.map((item, i) => <li key={i}>{item}</li>)}
					</ul>
				</section>

				<section>
					<h2>{t('privacy.section7Title')}</h2>
					<p>{t('privacy.section7Intro')}</p>
					<ul>
						{section7Rights.map((right, i) => <li key={i}>{right}</li>)}
					</ul>
					<p>
						{t('privacy.section7Contact')}{' '}
						<a href="mailto:info@ingegneriabernasconi.it">info@ingegneriabernasconi.it</a>.
					</p>
				</section>

				<section>
					<h2>{t('privacy.section8Title')}</h2>
					<p>
						{t('privacy.section8Text')}<br />
						<strong>{t('privacy.section8Authority')}</strong><br />
						Piazza Venezia 11, 00187 Roma<br />
						Sito web: <a href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer">www.garanteprivacy.it</a><br />
						Email: <a href="mailto:garante@gpdp.it">garante@gpdp.it</a><br />
						PEC: <a href="mailto:protocollo@pec.gpdp.it">protocollo@pec.gpdp.it</a>
					</p>
				</section>

				<section>
					<h2>{t('privacy.section9Title')}</h2>
					<p>{t('privacy.section9Text')}</p>
				</section>

				<div className="legal-back">
					<a href="/">{t('privacy.backHome')}</a>
				</div>
			</div>
		</div>
	);
}
